module.exports = __webpack_public_path__ + "img/logo-gundar.ae233cb0.png";